import StarIcon from "@material-ui/icons/Star";
import Form from "@saleor/components/Form";
import { SubmitPromise } from "@saleor/hooks/useForm";
import React from "react";

import StoreFormFeatureCheckbox from "../StoreFormFeatureCheckbox";

export interface FeaturedInitialFormData {
  id: string;
  isFeatured: boolean;
}

export interface StoreFeaturedStarProps {
  id: string;
  isFeatured: boolean;
  hasManageTenantPermission: boolean;
  onSubmit?: (data: FeaturedInitialFormData) => SubmitPromise;
}

const StoreFeaturedStar: React.FC<StoreFeaturedStarProps> = props => {
  const { id, isFeatured, hasManageTenantPermission, onSubmit } = props;

  const featuredInitialForm: FeaturedInitialFormData = {
    id,
    isFeatured
  };

  const handleOnSubmit = e => {
    onSubmit(e);
  };

  return (
    <Form initial={featuredInitialForm} onSubmit={handleOnSubmit}>
      {({ data, change, submit }) => (
        <>
          <StoreFormFeatureCheckbox
            id="isFeaturedCheckbox"
            icon={<StarIcon />}
            checkedIcon={<StarIcon />}
            disabled={!hasManageTenantPermission}
            checked={data.isFeatured}
            onChange={e => {
              change(e);
              submit();
            }}
            name="isFeatured"
            inputProps={{ "aria-label": "controlled" }}
          />
        </>
      )}
    </Form>
  );
};
StoreFeaturedStar.displayName = "StoreFeaturedStar";
export default StoreFeaturedStar;
